import { Button, ProgressSpinner, T } from "@bbnpm/bb-ui-framework";
import { useEffect, useRef, useState } from "react";
import "./landing.min.css";

const Landing = () => {
    const SITE_ADDRESS = process.env.PUBLIC_URL + "/";
    const [logInClicked, setLogInClicked] = useState(false);

    const buttonRef = useRef();
    useEffect(() => {
        const handleKeydown = (e) => {
            if (e.key === "Enter") {
                buttonRef.current?.click();
            }
        };
        const handleUnload = () => setLogInClicked(false);

        window.addEventListener("keydown", handleKeydown);
        window.addEventListener("unload", handleUnload);

        return () => {
            window.removeEventListener("keydown", handleKeydown);
            window.removeEventListener("unload", handleUnload);
        };
    }, []);

    useEffect(() => {
        if (logInClicked) {
            setTimeout(() => {
                setLogInClicked(false);
            }, 15000);
        }
    }, [logInClicked]);

    return (
        <div className="landing">
            <div className="top">
                {/* Flex, not Grid: Grid's tracks don't wrap, and this section stacks by running
                    out of room rather than at a breakpoint. The SCSS still uses Grid's tokens. */}
                <div className="leftBox">
                    {/* `as="h1"`: .leftBox h1 carries the margin and word-spacing. */}
                    <T.D2 as="h1">
                        Bloomberg <span>ANYWHERE</span>
                    </T.D2>
                    <T.H4>Access the Bloomberg Terminal wherever you are.</T.H4>
                    <T.Body>
                        Financial professionals need constant access to high-quality news, data and
                        analytics. Bloomberg keeps you connected from virtually anywhere, from any
                        type of device.
                    </T.Body>
                </div>
                <div className="rightBox">
                    <T.H2>Log into your Bloomberg Terminal</T.H2>
                    <T.Body>You will need your B-Unit to log in.</T.Body>
                    {!logInClicked && (
                        <Button
                            ref={buttonRef}
                            as="a"
                            kind="primary"
                            href={SITE_ADDRESS + "login"}
                            onClick={() => setLogInClicked(true)}
                        >
                            Log In
                        </Button>
                    )}
                    <div id="redirect_spinner" style={{ display: logInClicked ? "block" : "none" }}>
                        <ProgressSpinner
                            size="small"
                            label="Redirecting..."
                            labelPosition="right"
                        />
                    </div>
                    <span className="horizLine"></span>
                    <T.BodyLarge className="link-wrapper">
                        Not a Terminal user?&nbsp;
                        <a href="https://www.bloomberg.com/professional/request-demo/">
                            Request a demo
                        </a>
                    </T.BodyLarge>
                </div>
            </div>
            <div className="bottom">
                <div className="content">
                    <span className="leftImg"></span>
                    <div className="rightBox">
                        <T.H1 as="h2">Access on Mobile</T.H1>
                        <T.Body>
                            The Bloomberg Professional app keeps you connected to the same
                            market-moving news, data and information you depend on at your desktop
                            Terminal.
                        </T.Body>
                        <T.BodyLarge className="dl-links">
                            <strong>Available for: </strong>
                            <a href="https://apps.apple.com/us/app/bloomberg-professional/id407761767?platform=ipad">
                                iPad
                            </a>
                            ,{" "}
                            <a href="https://apps.apple.com/us/app/bloomberg-professional/id407761767">
                                iPhone
                            </a>
                            , and{" "}
                            <a href="https://play.google.com/store/apps/details?id=com.bloomberg.android.anywhere">
                                Android
                            </a>
                        </T.BodyLarge>
                        <a
                            href="https://apps.apple.com/us/app/bloomberg-professional/id407761767"
                            className="appstoreBtn"
                        >
                            Apple
                        </a>
                        <a
                            href="https://play.google.com/store/apps/details?id=com.bloomberg.android.anywhere"
                            className="playstoreBtn"
                        >
                            Google
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Landing;
